import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'ux-treatment-relatives',
	templateUrl: './treatment-relatives.component.html',
	styleUrls: ['./treatment-relatives.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [
		CommonModule, // For ngIf, ngFor
		MatCardModule, // For mat-card
		MatButtonModule, // For mat-raised-button
		TranslateModule // To enable the | translate pipe
	]
})
export class TreatmentRelativesComponent {
	@Input() childTreatments: any[] = [];
	@Input() parentTreatment: any;

	@Output() treatmentSelected = new EventEmitter<any>();

	goToTreatment(treatment: any): void {
		this.treatmentSelected.emit(treatment);
	}

	trackByFn(index: number, item: any): any {
		return item.id || index;
	}
}
